<div class="inspection-container">
  <ng-container *ngIf="inspectionReport">
    <div class="report-menu-container" fxLayout="row wrap">
      <div fxLayoutAlign="start center" fxFlexOffset="10px"></div>
      <div fxLayoutAlign="end end">
        <ng-container *ngIf="isEditing || isDraftProcessing">
          <button
            mat-button
            color="primary"
            class="custom-button"
            [disabled]="isProcess || isReadOnly() || isDraftProcessing || (isDesktopAndOffline && !isOfflinePreviewReady)"
            (click)="openPropertiesDialog()"
          >
            <mat-icon>assignment</mat-icon>
            {{ "inspectionReport.Properties" | translate }}
          </button>
          <button
            mat-button
            color="primary"
            class="custom-button"
            [disabled]="isProcess || isReadOnly() || !isEditabletexts || isDraftProcessing || (isDesktopAndOffline && !isOfflinePreviewReady)"
            (click)="openEditableTextsDialog()"
          >
            <mat-icon class="text-icon">border_color</mat-icon>
            {{ "inspectionReport.EditReportText" | translate }}
          </button>
          <button
            mat-button
            color="primary"
            [disabled]="isDesktopAndOffline || isBrian"
            [ngClass]="{ incomplete: isDesktopAndOffline }"
            (click)="shareDraftInspectionReportPdf()"
          >
            <mat-icon>share</mat-icon>
            {{ "inspectionReport.ShareDraft" | translate }}
          </button>
          <button
            *ngIf="!isDraftProcessing"
            mat-button
            class="download"
            color="primary"
            [disabled]="isProcess || isProcessingCreateReport || (isDesktopAndOffline && !isOfflinePreviewReady)"
            (click)="downloadDraftInspectionReportPdf()"
          >
            <mat-icon class="pdf-icon">picture_as_pdf</mat-icon>
            {{ "inspectionReport.DraftDownload" | translate }}
          </button>
          <button
            *ngIf="isDraftProcessing"
            mat-button
            class="download processing"
            color="primary"
            [matTooltip]="'inspectionReport.CancelGeneFinalPdf' | translate"
            (click)="cancelGeneratePDF(true)"
          >
            <mat-icon class="pdf-icon">picture_as_pdf</mat-icon>
            {{ "inspectionReport.CancelProcessing" | translate }}
          </button>
          <div
            class="tooltip-wrapper"
            [matTooltip]="isDesktopAndOffline && !isDefaultOfflineUser ? ('inspectionReport.DoneDisabledHint' | translate) : ''"
          >
            <button
              mat-button
              mat-raised-button
              class="incomplete"
              color="warn"
              [disabled]="isProcess || isDone || isReadOnly() || isDraftProcessing || (isDesktopAndOffline && !isDefaultOfflineUser)"
              (click)="checkReportValidation()"
            >
              <mat-icon class="done-icon">check</mat-icon>
              {{ "inspectionReport.Done" | translate }}
            </button>
          </div>
        </ng-container>
        <ng-container *ngIf="isCompleted || isFinalProcessing">
          <button
            *ngIf="isCompleted"
            mat-button
            color="primary"
            [disabled]="isDownload || isDesktopAndOffline || isBrian"
            (click)="openShareDialog()"
          >
            <mat-icon>share</mat-icon>
            {{ "inspectionReport.Share" | translate }}
          </button>
          <button
            *ngIf="isCompleted"
            mat-button
            class="download"
            color="primary"
            [disabled]="isDownload"
            (click)="downloadInspectionReportPdf()"
            download="report.pdf"
          >
            <mat-icon class="pdf-icon">picture_as_pdf</mat-icon>
            {{ "inspectionReport.Download" | translate }}
          </button>
          <button
            *ngIf="isFinalProcessing"
            mat-button
            class="download processing"
            color="primary"
            [matTooltip]="'inspectionReport.CancelGeneFinalPdf' | translate"
            (click)="cancelGeneratePDF(false)"
          >
            <mat-icon class="pdf-icon">picture_as_pdf</mat-icon>
            {{ "inspectionReport.CancelProcessing" | translate }}
          </button>
        </ng-container>
        <ng-container *ngIf="!isError && isCompleted">
          <button mat-button color="primary" class="completed" disabled>
            <mat-icon class="completed-icon">task</mat-icon>
            <span class="completed-span">{{ "inspectionReport.Completed" | translate }}</span>
          </button>
          <button
            mat-button
            color="primary"
            class="completed"
            [disabled]="isReadOnly() || isDeletedInspection || isFinalProcessing"
            (click)="createNewVersionReport()"
          >
            <span class="completed-span">{{ "inspectionReport.ReEdit" | translate }}</span>
          </button>
        </ng-container>
      </div>
    </div>
    <div class="inspection-data-management-content">
      <ng-container *ngIf="!isCompleted">
        <div class="report-preview">
          <ng-container *ngIf="!isEdge(browserName) && !isDesktopAndOffline">
            <iframe *ngIf="previewUrl" [src]="previewUrl" #iframe>
              <h3>{{ "inspectionReport.LoadPreview" | translate }}</h3>
            </iframe>
          </ng-container>
          <ng-container *ngIf="isDesktopAndOffline">
            <app-report-preview-offline id="offline-draft-report" (pageRendered)="previewRendered($event)"> </app-report-preview-offline>
          </ng-container>
          <ng-container *ngIf="isEdge(browserName)">
            <iframe #edgeIframe>
              <h3>{{ "inspectionReport.LoadPreview" | translate }}</h3>
            </iframe>
          </ng-container>
        </div>
      </ng-container>
      <ng-container *ngIf="isCompleted">
        <div *ngIf="!isDeviceNameIpad(deviceName)" class="report-preview">
          <h3 *ngIf="!isPlugin" class="display-message">
            {{ "inspectionReport.MsgInstallPDFViewer" | translate }}
          </h3>
          <ng-container *ngIf="isPlugin && (!isSafari(browserName) || !isDesktopAndOffline)">
            <iframe *ngIf="pdfUrl" [src]="pdfUrl" type="application/pdf">
              <h3 *ngIf="!isError && isDownload">{{ "inspectionReport.LoadPDF" | translate }}</h3>
              <h3 *ngIf="isError">{{ "inspectionReport.PageNotFound" | translate }}</h3>
            </iframe>

            <h4 *ngIf="isError && !isProcessingCreateReport" class="display-message">
              {{ "inspectionReport.UnDisplayPDFRpt" | translate }}
            </h4>
            <h4 *ngIf="isError && isProcessingCreateReport && !isDesktopAndOffline" class="display-message">
              {{ "inspectionReport.MsgPressRefresh1" | translate }}
            </h4>
            <h4 *ngIf="isError && isProcessingCreateReport && isDesktopAndOffline" class="display-message">
              {{ "inspectionReport.MsgPressRefresh2" | translate }}
            </h4>
          </ng-container>

          <ng-container *ngIf="!isSafari(browserName) && isDesktopAndOffline">
            <div>Report view</div>
          </ng-container>

          <ng-container *ngIf="isPlugin && isSafari(browserName)">
            <object *ngIf="pdfUrl" [data]="pdfUrl" type="application/pdf">
              <h3 *ngIf="!isError && isDownload">{{ "inspectionReport.LoadPDF" | translate }}</h3>
              <h3 *ngIf="isError">{{ "inspectionReport.PageNotFound" | translate }}</h3>
            </object>

            <h4 *ngIf="isError && !isProcessingCreateReport" class="display-message">
              {{ "inspectionReport.UnDisplayPDFRpt" | translate }}
            </h4>
            <h4 *ngIf="isError && isProcessingCreateReport" class="display-message">
              {{ "inspectionReport.MsgPressRefresh" | translate }}
            </h4>
          </ng-container>
        </div>

        =
        <div *ngIf="isDeviceNameIpad(deviceName)" class="report-preview-ipad">
          <h3 *ngIf="!isPlugin">
            {{ "inspectionReport.MsgInstallPDFViewer" | translate }}
          </h3>

          <ng-container *ngIf="isPlugin && !isSafari(browserName) && !isDesktopAndOffline">
            <iframe *ngIf="pdfUrl" [src]="pdfUrl" type="application/pdf">
              <h3 *ngIf="!isError && isDownload">{{ "inspectionReport.LoadPDF" | translate }}</h3>
              <h3 *ngIf="isError">{{ "inspectionReport.PageNotFound" | translate }}</h3>
            </iframe>
          </ng-container>

          <ng-container *ngIf="!isSafari(browserName) && isDesktopAndOffline">
            <div>Report view</div>
          </ng-container>

          <ng-container *ngIf="isPlugin && isSafari(browserName)">
            <object *ngIf="pdfUrl" [data]="pdfUrl" type="application/pdf">
              <h3 *ngIf="!isError && isDownload">{{ "inspectionReport.LoadPDF" | translate }}</h3>
              <h3 *ngIf="isError">{{ "inspectionReport.PageNotFound" | translate }}</h3>
            </object>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </ng-container>
</div>
